import TileSparkline from './TileSparkline';

export default TileSparkline;

export { plotSparkline, sparkSegments } from './TileSparkline';
export type { ISparkPoint, ITileSparklineProps } from './TileSparkline';
